import { __extends } from "tslib";
import { EventDispatcher, AbstractionBase } from '@awayjs/core';
import { StageEvent } from '@awayjs/stage';
import { RenderEntity } from './base/RenderEntity';
import { ViewEvent, PickGroup } from '@awayjs/view';
var RendererPool = /** @class */ (function () {
    function RendererPool(renderGroup, rendererClass) {
        this.id = AbstractionBase.ID_COUNT++;
        this.renderGroup = renderGroup;
        this._rendererClass = rendererClass;
        this.materialClassPool = rendererClass.materialClassPool;
    }
    RendererPool.prototype.requestAbstraction = function (asset) {
        return this._rendererClass;
    };
    return RendererPool;
}());
export { RendererPool };
/**
 * @class away.pool.RenderGroup
 */
var RenderGroup = /** @class */ (function (_super) {
    __extends(RenderGroup, _super);
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function RenderGroup(view, rendererClass) {
        var _this = _super.call(this) || this;
        _this._mappers = new Array();
        _this._elementsPools = {};
        _this.id = AbstractionBase.ID_COUNT++;
        _this.view = view;
        _this.stage = view.stage;
        _this.pickGroup = PickGroup.getInstance(view);
        _this._rendererPool = new RendererPool(_this, rendererClass);
        _this._materialClassPool = _this._rendererPool.materialClassPool;
        _this.view.backgroundColor = rendererClass.defaultBackground;
        _this._onSizeInvalidateDelegate = function (event) { return _this.onSizeInvalidate(event); };
        _this._onContextUpdateDelegate = function (event) { return _this.onContextUpdate(event); };
        _this.stage.addEventListener(StageEvent.CONTEXT_CREATED, _this._onContextUpdateDelegate);
        _this.stage.addEventListener(StageEvent.CONTEXT_RECREATED, _this._onContextUpdateDelegate);
        _this.view.addEventListener(ViewEvent.INVALIDATE_SIZE, _this._onSizeInvalidateDelegate);
        return _this;
    }
    // public static clearAllInstances(): void {
    // 	for (const key in this._instancePool) {
    // 		this._instancePool[key].clearAll();
    // 		delete this._instancePool[key];
    // 	}
    // }
    RenderGroup.getInstance = function (view, rendererClass) {
        return rendererClass.renderGroupPool[view.id]
            || (rendererClass.renderGroupPool[view.id] = new RenderGroup(view, rendererClass));
    };
    RenderGroup.clearInstance = function (view, rendererClass) {
        var renderGroup = rendererClass.renderGroupPool[view.id];
        if (renderGroup) {
            renderGroup.clearAll();
            delete rendererClass.renderGroupPool[view.id];
        }
    };
    /**
     * Clears the resources used by the RenderGroup.
     */
    RenderGroup.prototype.clearAll = function () {
        this.stage.removeEventListener(StageEvent.CONTEXT_CREATED, this._onContextUpdateDelegate);
        this.stage.removeEventListener(StageEvent.CONTEXT_RECREATED, this._onContextUpdateDelegate);
        this.view.removeEventListener(ViewEvent.INVALIDATE_SIZE, this._onSizeInvalidateDelegate);
    };
    RenderGroup.prototype.update = function (partition) {
        //update mappers
        var len = this._mappers.length;
        for (var i = 0; i < len; i++)
            this._mappers[i].update(partition, this);
    };
    RenderGroup.prototype.invalidate = function () {
        this._invalid = true;
    };
    RenderGroup.prototype._addMapper = function (mapper) {
        if (this._mappers.indexOf(mapper) != -1)
            return;
        this._mappers.push(mapper);
    };
    RenderGroup.prototype._removeMapper = function (mapper) {
        var index = this._mappers.indexOf(mapper);
        if (index != -1)
            this._mappers.splice(index, 1);
    };
    /**
     *
     */
    RenderGroup.prototype.onSizeInvalidate = function (event) {
        this.dispatchEvent(event);
    };
    /**
     * Assign the context once retrieved
     */
    RenderGroup.prototype.onContextUpdate = function (event) {
        this.dispatchEvent(event);
    };
    RenderGroup.prototype.getRenderElements = function (elements) {
        var el = this._elementsPools[elements.assetType];
        /**
         * @todo Remove me to prevent leaks
         */
        if (!el) {
            el =
                this._elementsPools[elements.assetType] =
                    new (RenderGroup._renderElementsClassPool[elements.assetType])(this.stage, this._materialClassPool, this);
        }
        return el;
    };
    RenderGroup.prototype.requestAbstraction = function (asset) {
        return RenderEntity;
    };
    RenderGroup.prototype.getRenderer = function (partition) {
        return partition.getAbstraction(this._rendererPool);
    };
    /**
     *
     * @param imageObjectClass
     */
    RenderGroup.registerElements = function (renderElementsClass, elementsClass) {
        RenderGroup._renderElementsClassPool[elementsClass.assetType] = renderElementsClass;
    };
    RenderGroup._renderElementsClassPool = {};
    return RenderGroup;
}(EventDispatcher));
export { RenderGroup };
